import { render, staticRenderFns } from "./Especialidade.vue?vue&type=template&id=1851b619"
import script from "./Especialidade.vue?vue&type=script&lang=js"
export * from "./Especialidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports